import { segment } from '@actions/analytics';
import { useRouter } from 'next/router';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getPlusSubscriptionInfoLatest } from '@api/selectors/subscription';

const useRankPredictorSegmentAnalytics = () => {
  const router = useRouter();
  const { query } = router;
  const { goalUID, exam_type } = query;

  const {
    subscription = {},
    expiredAt: expired_at,
    timeRemaining: time_remaining
  } = useMyInfo(getPlusSubscriptionInfoLatest(goalUID)) ?? {};

  const { duration = 'NA', value = {} } = subscription;

  return (actionKey, additionalProps = {}) => {
    segment.track(actionKey, {
      goal_name: value?.name ?? 'NA',
      goal_uid: goalUID,
      exam_type,
      subscription_duration: duration,
      subscription_end_date: expired_at,
      is_subscription_active: time_remaining > 0,
      last_primary_source_section: 'Rank Predictor',
      ...additionalProps
    });
  };
};

export default useRankPredictorSegmentAnalytics;
